import axios from "axios";
import { logoutApp } from "../AuthContext/AuthProvider";
import { url } from "../Func_genericas/hosts";
// import { useNavigate } from "react-router-dom";



// const navigate = useNavigate();


const api = axios.create({
  // baseURL: process.env.REACT_APP_VULPES,
  baseURL: url,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      // if (error.response && error.response.status === 401) {
      // window.location.replace('https://vulpes.pt/')
      logoutApp(); 
      return window.location.href = '/'

    }
    return Promise.reject(error);
  }
);



// api.interceptors.request.use(
//   (config: any) => {
//     const token = localStorage.getItem("token") || "";
//     if (!config.headers?.Authorization && token) {
//       config.headers = {
//         ...config.headers,
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       };
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

export default api;
